<template>
  <div class="d-flex justify-content-center align-items-center vh-100 bg-light">
    <div class="card shadow p-4" style="max-width: 400px; width: 100%; border: none;">
      <h2 class="text-center mb-4" style="color: #233d72;">Iniciar Sesión</h2>
      <form @submit.prevent="iniciarSesion">
        <div class="mb-3">
          <label for="usuario" class="form-label">Usuario</label>
          <input
            type="text"
            id="usuario"
            v-model="usuario"
            class="form-control"
            required
          />
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Contraseña</label>
          <input
            type="password"
            id="password"
            v-model="password"
            class="form-control"
            required
          />
        </div>
        <button type="submit" class="btn w-100" style="background-color: #233d72; color: white;">
          Ingresar
        </button>
        <p v-if="error" class="mt-3 text-danger text-center">{{ error }}</p>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Login',
  data() {
    return {
      usuario: '',
      password: '',
      error: ''
    };
  },
  methods: {
    async iniciarSesion() {
      try {
        const response = await axios.post('http://localhost:3000/api/administradores/login', {
          usuario: this.usuario,
          password: this.password
        });

        const token = response.data.token;
        localStorage.setItem('token', token);
        this.$router.replace('/dashboard');
      } catch (err) {
        console.error(err);
        this.error = err.response?.data?.mensaje || 'Error al iniciar sesión';
      }
    }
  }
};
</script>

<style scoped>
body {
  background-color: #adb4c3;
}
</style>
